<template>
	<div
		class="openingHours"
		v-if="openingHoursData && defaultOpeningHoursData"
	>
		<button
			class="openingHours__trigger large-screen button"
			@click="open()"
		>
			<p v-if="defaultOpeningHoursData.name" class="openingHours__unit">
				{{ defaultOpeningHoursData.name }}
			</p>
			<p
				v-if="defaultOpeningHoursData.todaysOpeningHours"
				class="openingHours__today"
			>
				<!-- {{ translations.todaysOpeningHoursLabel }}: -->
				{{ defaultOpeningHoursData.todaysOpeningHours }}
			</p>
		</button>
		<div class="small-screen">
			<p v-if="defaultOpeningHoursData.name" class="openingHours__unit">
				{{ defaultOpeningHoursData.name }}
			</p>
			<p
				v-if="defaultOpeningHoursData.todaysOpeningHoursModal"
				class="openingHours__today"
			>
				<!-- {{ translations.todaysOpeningHoursLabel }}: -->
				{{ defaultOpeningHoursData.todaysOpeningHoursModal }}
			</p>
			<button class="openingHours__trigger button" @click="open()">
				{{ translations.mobileTrigger }}
			</button>
		</div>
		<dialog class="openingHours__modal" ref="dialog" :id="id">
			<div class="openingHours__modal-header">
				<button
					class="openingHours__modal-close-button button--nostyling"
					aria-label="Luk dialog"
					@click="close()"
				>
					<div v-html="IconCross"></div>
				</button>
			</div>
			<div
				class="openingHours__modal-content"
				:key="selectedDepartmentId"
			>
				<Dropdown
					v-if="openingHoursData.openingHours.departments.length > 1"
					class="openingHours__modal-content-dropdown"
					li-selector="button"
				>
					<template #btn>
						<div
							class="bp-dropdown__btn-text"
							id="selectDepartment"
							ref="dropdown"
							tabindex="-1"
						>
							{{ selectedDepartmentName }}
						</div>
					</template>
					<template #body>
						<ul
							class="ul--nostyling js-dropdown-listbox"
							id="departmentList"
							aria-labelledby="selectDepartment"
							role="listbox"
						>
							<li
								role="option"
								v-for="(department, idx) in openingHoursData
									.openingHours.departments"
								:key="department.id"
								:aria-selected="
									selectedDepartmentId === department.id
										? 'true'
										: 'false'
								"
								:id="'subject-' + department.id"
								:aria-label="
									department.name +
									' ' +
									translations.xofy
										.replace('X', idx + 1)
										.replace(
											'Y',
											openingHoursData.openingHours
												.departments.length
										)
								"
							>
								<button
									class="openingHours__modal-content-dropdow-btn"
									:class="{
										disabled:
											selectedDepartmentId ===
											department.id,
									}"
									@click="selectDepartment(department.id)"
									:aria-disabled="
										selectedDepartmentId === department.id
									"
									:disabled="
										selectedDepartmentId === department.id
									"
								>
									{{ department.name }}
								</button>
							</li>
						</ul>
					</template>
				</Dropdown>
				<p
					v-if="openingHoursData.name"
					class="openingHours__modal-content-name"
				>
					{{ openingHoursData.name }}
				</p>
				<p
					v-if="openingHoursData.adresse1"
					class="openingHours__modal-content-adresse1"
				>
					{{ openingHoursData.adresse1 }}
				</p>
				<p
					v-if="openingHoursData.adresse2"
					class="openingHours__modal-content-adresse2"
				>
					{{ openingHoursData.adresse2 }}
				</p>
				<p
					v-if="openingHoursData.phone"
					class="openingHours__modal-content-phone"
				>
					Tlf.
					<a
						:href="'tel:' + openingHoursData.phone"
						class="inline-link"
					>
						{{ formattedPhoneNumber }}
					</a>
				</p>
				<p
					v-if="openingHoursData.email"
					class="openingHours__modal-content-phone"
				>
					<span>Mail. </span>
					<a
						:href="'mailto:' + openingHoursData.email"
						class="inline-link"
					>
						{{ openingHoursData.email }}
					</a>
				</p>
				<p
					v-if="openingHoursData.googleLink"
					class="openingHours__modal-content-googlelink"
				>
					<a
						:href="openingHoursData.googleLink"
						target="_blank"
						class="inline-link"
					>
						{{ openingHoursData.googleTitle }}
					</a>
				</p>
				<br />
				<p v-if="openingHoursData.todaysOpeningHoursModal">
					{{ openingHoursData.todaysOpeningHoursModal }}
				</p>
				<hr class="openingHours__modal-content-divider" />
				<div class="openingHours__modal-content-openingHours">
					<h3 class="header-extra-small">
						{{ translations.listHeader }} {{ chosenWeekNumber }}
					</h3>
					<Datepicker
						:id="'weekpicker' + Math.floor(Math.random() * 100)"
						name="fromDate"
						:value="selectedDate"
						@update="updateFromDate"
						:defaultDate="new Date()"
						label="Uge"
						:useAsWeekpicker="true"
					></Datepicker>
					<ul>
						<li
							v-for="openingHour in filteredOpeningHoursList"
							:key="openingHour.day"
						>
							<p>{{ openingHour.day }}</p>
							<p>{{ openingHour.value }}</p>
						</li>
					</ul>
				</div>
				<div
					class="openingHours__modal-content-readmore buttons buttons--cta"
				>
					<a
						v-for="link in openingHoursData.links"
						:key="link.name"
						class="buttons__button"
						:href="link.url"
					>
						{{ link.name }}
					</a>
				</div>
			</div>
			<Spinner v-if="loading" />
		</dialog>
	</div>
	<div v-else class="openingHours">
		<div class="openingHours__trigger large-screen button">
			<!-- <p v-if="defaultName" class="openingHours__unit">
				{{ defaultName }}
			</p>
			<p class="openingHours__today">
				{{ translations.todaysOpeningHoursLabel }}:
				&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
			</p> -->
		</div>
	</div>
	<span ref="openingHoursRef"></span>
</template>

<script setup>
import { ref, onMounted, computed, onBeforeUnmount } from "vue";
import IconCross from "../../../views/icons/cross.cshtml";
import Datepicker from "../datepicker/datepicker.vue";
import Dropdown from "../../shared/script/vue/Dropdown.vue";
import Spinner from "../../shared/script/vue/Spinner.vue";

const id = ref(null);
const apiurl = ref(null);
const selectedDepartmentId = ref(null);
const defaultOpeningHoursData = ref(null);
const translations = ref({});
const selectedDate = ref(utilities.formatDate(new Date()));
const openingHoursData = ref(null);
const selectedDepartmentName = ref(null);
const originalDepartment = ref(null);
const loading = ref(false);

const dialog = ref("dialog");
const dropdown = ref("dropdown");
const openingHoursRef = ref("openingHoursRef");

const filteredOpeningHoursList = computed(() => {
	return openingHoursData.value?.openingHours.openingHoursList?.filter(
		(openingHour) => openingHour.day !== null
	);
});

const formattedPhoneNumber = computed(() => {
	return openingHoursData.value?.phone.replace(
		/(\d{2})(\d{2})(\d{2})(\d{2})/,
		"$1 $2 $3 $4"
	);
});

onMounted(async () => {
	setDataFromAttributes();
	defaultOpeningHoursData.value = await fetchData();
	selectedDepartmentName.value = translations.value.dropdownDeafult;

	checkHash();

	window.addEventListener("resize", handleResize);
	window.addEventListener("hashchange", checkHash);

	setTimeout(() => {
		if (dialog.value) {
			dialog.value.addEventListener("click", dialogOnClick);
		}
	}, 100);
});

onBeforeUnmount(() => {
	dialog.value.removeEventListener("click", dialogOnClick);
	window.removeEventListener("resize", handleResize);
	window.removeEventListener("hashchange", checkHash);
});

const setDataFromAttributes = () => {
	const dataProps = openingHoursRef.value?.parentElement?.dataset;
	if (dataProps) {
		id.value = dataProps.id;
		apiurl.value = dataProps.apiurl;
		selectedDepartmentId.value = dataProps.guid;
		translations.value = JSON.parse(dataProps.translations);
	}
};

const fetchData = async () => {
	try {
		const response = await setOpeningHours(selectedDepartmentId.value);
		return response;
	} catch (err) {
		console.warn(err);
		return false;
	}
};

const setOpeningHours = async (id) => {
	loading.value = true;
	let response = await fetch(
		`${apiurl.value}?guid=${id}&from=${selectedDate.value}`
	);
	response = await response.json();
	if (response) {
		openingHoursData.value = response;
		selectedDepartmentName.value = openingHoursData.value.name;

		if (originalDepartment.value) {
			openingHoursData.value?.openingHours?.departments?.push(
				originalDepartment.value
			);
		}
		loading.value = false;
		return response;
	}
	loading.value = false;
};

const open = (change) => {
	const shouldChangeHash = change || true;
	document.querySelector("body").classList.add("no-scroll");
	dialog.value.showModal();
	if (shouldChangeHash) {
		changeHash("departmentId", selectedDepartmentId.value);
	}
};

const close = () => {
	document.querySelector("body").classList.remove("no-scroll");
	dialog.value.close();
	changeHash("departmentId", null);
};

const dialogOnClick = (event) => {
	// close dialog on click outside.
	if (event.target === dialog.value) {
		close();
	}
};

const changeHash = (name, value) => {
	if (!value) {
		history.pushState(
			"",
			document.title,
			window.location.pathname + window.location.search
		);
	} else {
		window.location.hash = name + "_" + value;
	}
};

const checkHash = () => {
	// Check if the parent element is visible, in order to not open in both small and large header
	const visible = openingHoursRef.value?.parentElement
		?.closest("header")
		.checkVisibility();
	if (visible) {
		const hash = window.location.hash;
		// if we have a hash with departmentId
		if (hash.indexOf("departmentId") > 0) {
			// Get the id
			const id = hash.split("_")[1];
			// if the id is not the same as the one already selected, fetch new ones.
			if (id !== selectedDepartmentId.value) {
				selectedDepartmentId.value = id;
				setOpeningHours(id);
			}
			setTimeout(() => {
				open(false);
			}, 300);
		}
	}
};

const handleResize = () => {
	const headerLargeDialog = document.getElementById(
		"headerLargeOpeningHours"
	);
	const headerSmallDialog = document.getElementById(
		"headerSmallOpeningHours"
	);
	const screenWidth = window.innerWidth;
	if (headerLargeDialog && headerLargeDialog.open && screenWidth < 992) {
		close();
	}
	if (headerSmallDialog && headerSmallDialog.open && screenWidth > 992) {
		close();
	}
};

const chosenWeekNumber = computed(() => {
	return utilities.getWeek(utilities.formatDateToSlash(selectedDate.value));
});

const updateFromDate = (date) => {
	selectedDate.value = date;
	setOpeningHours(selectedDepartmentId.value);
};

const selectDepartment = async (id) => {
	selectedDepartmentId.value = id;
	await setOpeningHours(id);
	dropdown.value.focus();
	changeHash("departmentId", id);
};
</script>
<style lang="scss"></style>
